import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '~/components/ComingSoon';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const JadePage = () => {
  return <ComingSoon title="J.A.D.E." subtitle="Our Products" />;
};

export const Route = createFileRoute('/products/jade')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: JadePage,
});

